import React, {FC, useEffect, useState} from 'react';

import {insertScript, isScriptAlreadyAdded} from '@optimaxdev/utils';
import {RecurlyProvider, Elements} from '@recurly/react-recurly';
import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';
import {PaymentType} from 'types/PaymentMethodsType';

import {PAYMENTS} from '../../constants/paymentStep';
import {
    getIsSelectedByKey,
    getPaymentMethodByKey,
} from '../../store/selectors/paymentStep/paymentStep';
import {PayPalIcon} from '../icons/checkoutIcons';
import {PaymentRecurlyPayPalFormConnected} from '../paymentRecurlyPayPalForm/paymentRecurlyPayPalForm';
import {PaymentWrapperConnected} from '../paymentWrapper/paymentWrapper';

const REQURLY_SCRIPT_SRC = 'https://js.recurly.com/v4/recurly.js';

export type PropsType = {
    method: PaymentType;
    isSelected: boolean;
};

/**
 * The main wrapper for recurly stuff
 * the recurly won't work without it, because it requires an external script to process form
 *
 * @constructor
 */
export const PaymentRecurlyPayPal: FC<PropsType> = ({isSelected, method}) => {
    const [isRecurlyScriptLoaded, setRecurlyScriptLoaded] = useState(false);

    useEffect(() => {
        const isScriptLoaded = isScriptAlreadyAdded(REQURLY_SCRIPT_SRC);
        if (isScriptLoaded) setRecurlyScriptLoaded(true);
        if (isSelected && !isScriptLoaded)
            insertScript(REQURLY_SCRIPT_SRC, false, () => setRecurlyScriptLoaded(true));
    }, [isSelected]);

    if (!method.publishableKey) return null;

    const isReadyToRenderInner = isSelected && isRecurlyScriptLoaded;

    return (
        <PaymentWrapperConnected code={method.code} isSelected={isSelected} title={<PayPalIcon />}>
            {isReadyToRenderInner && (
                <RecurlyProvider publicKey={method.publishableKey}>
                    <Elements>
                        <PaymentRecurlyPayPalFormConnected title={method.title} />
                    </Elements>
                </RecurlyProvider>
            )}
        </PaymentWrapperConnected>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    isSelected: getIsSelectedByKey(store, PAYMENTS.METHOD_RECURLY_PAYPAL),
    method: getPaymentMethodByKey(store, PAYMENTS.METHOD_RECURLY_PAYPAL),
});

export const PaymentRecurlyPayPalConnected = connect(mapStateToProps)(PaymentRecurlyPayPal);
